module.exports = __webpack_public_path__ + "static/media/silver.0b7f0cf8.png";